import {useEffect, useState} from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/AuthenticationContext';
import {Col, Spinner} from 'react-bootstrap';
import CryptoJS from "crypto-js";
import {downloadInvoice} from "../Utils/dowloadInvoice";
import logoImg from "../assets/netcomet.png";

export function Authentication() {
	const history = useHistory();

	const { signIn } = useAuth();

	const [loading, setLoading] = useState(true);
	const [message, setMessage] = useState('');

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const documentParam = urlParams.get('d');
		const phoneParam = urlParams.get('t');
		const tokenParam = urlParams.get('t');
		const invoiceParam = urlParams.get('i');

		if (documentParam && phoneParam && invoiceParam) {
			signIn(documentParam.replace(/\.|-/g, '').trim(), phoneParam.replace(/\(|\)|-/g, '').trim(), null)
				.then(() => {
					history.push('pagamento_avulso/'+invoiceParam);
				}).catch(() => {
					history.push('login');
				})
		} else if (tokenParam && !documentParam) {
			let obj_json = JSON.parse(atob(tokenParam));
			let key = CryptoJS.PBKDF2(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_KEY as string, process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_SALT as string, { hasher: CryptoJS.algo.SHA512, keySize: 64/8, iterations: 999});
			let decrypted = CryptoJS.AES.decrypt(obj_json.ciphertext, key, { iv: CryptoJS.enc.Hex.parse(process.env.REACT_APP_SUPERGER_API_AUTHENTICATION_TOKEN_IV_HEX as string)});
			let dataParameters = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

			if (dataParameters.r === 'anexos') {
				signIn(dataParameters.d.replace(/\.|-/g, '').trim(), dataParameters.t.replace(/\(|\)|-/g, '').trim(), null)
					.then(() => {
						history.push('anexos/'+tokenParam);
					}).catch(() => {
						history.push('login');
					})
			} else if (dataParameters.local === 'boleto') {
				downloadInvoice(dataParameters.d.replace(/\.|-/g, '').trim(), dataParameters.t.replace(/\(|\)|-/g, '').trim(), dataParameters.id_movimentacao, dataParameters.pix)
					.then( (result) => {
						setLoading(false);
						setMessage(result)
					}).catch(  (error) => {
						setLoading(false);
						setMessage(error)
					});
			} else {
				history.push('login');
			}
		} else {
			history.push('login');
		}
	},[history, signIn]);

	return (
		<>
			{loading && <div className="vh-100 justify-content-center align-items-center d-flex">
				<Spinner animation="border" role="status"/>
			</div>}
			{!loading && <div className="vh-100 justify-content-center align-items-center d-grid ms-3 me-3">
					<Col md={12} sm={12} className="text-center">
							<img src={logoImg} className="mb-5" alt="Logo Netcomet"/>
							{message}
					</Col>
			</div>}
		</>
	);
}
